// pages/Admissions.js
import React from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';

const Admissions = () => {
  return (
    <div className="admissions-container">
      {/* Enhanced Header Section */}
      <div className="about-header text-center gap-1 mb-6" style={{ backgroundColor: '#03438F' }}>
        <h1 className="text-2xl sm:text-3xl font-bold text-center" style={{ color: '#F57A25' }}>
          Admissions
        </h1>
        <p className="text-center text-base sm:text-lg mb-1 text-white">
          Join Dream India School Tiruvuru for quality CBSE education.
        </p>
        <p className="text-center text-base sm:text-lg mb-1 text-white">
          Our admission process is transparent,
          student-friendly, and designed to welcome students of all backgrounds while maintaining academic excellence.
        </p>
      </div>

      <div className="admissions-content">
        <div className="grid">
          {/* Admission Open Session */}
          <div className="col-12 md:col-6 mb-4">
            <Card className="admission-card h-full" style={{
              borderRadius: '20px',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
              transition: 'all 0.3s ease',
              border: 'none',
              overflow: 'hidden'
            }}>
              <div className="card-header-enhanced">
                <div className="flex align-items-center mb-4">
                  <span className="text-3xl mr-3" style={{ color: '#F57A25' }}>📅</span>
                  <h3 className="text-2xl font-bold m-0" style={{ color: '#03438F' }}>Admission Open Session 2025–26</h3>
                </div>
              </div>
              <div className="card-content">
                <div className="admission-highlight mb-4">
                  <div className="flex align-items-center">
                    <span className="highlight-icon mr-3" style={{ color: '#F57A25' }}>🎯</span>
                    <div>
                      <h4 className="text-lg font-semibold mb-2" style={{ color: '#03438F' }}>Open for All Grades</h4>
                      <p className="leading-relaxed" style={{ color: '#666' }}>
                        Admissions for the 2025–26 session are now open for Nursery to Class XII. 
                        We invite parents to explore our CBSE curriculum, modern facilities, and 
                        comprehensive co-curricular programs.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="admission-benefits">
                  <div className="benefit-item">
                    <span className="benefit-icon">🏫</span>
                    <span>Modern Infrastructure</span>
                  </div>
                  <div className="benefit-item">
                    <span className="benefit-icon">👨‍🏫</span>
                    <span>Experienced Faculty</span>
                  </div>
                  <div className="benefit-item">
                    <span className="benefit-icon">📚</span>
                    <span>CBSE Curriculum</span>
                  </div>
                </div>
              </div>
            </Card>
          </div>

          {/* Online Registration */}
          <div className="col-12 md:col-6 mb-4">
            <Card className="admission-card h-full" style={{
              borderRadius: '20px',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
              transition: 'all 0.3s ease',
              border: 'none',
              overflow: 'hidden'
            }}>
              <div className="card-header-enhanced">
                <div className="flex align-items-center mb-4">
                  <span className="text-3xl mr-3" style={{ color: '#F57A25' }}>💻</span>
                  <h3 className="text-2xl font-bold m-0" style={{ color: '#03438F' }}>Online Registration</h3>
                </div>
              </div>
              <div className="card-content">
                <p className="leading-relaxed mb-4" style={{ color: '#666' }}>
                  Our secure online registration system allows parents to apply from the 
                  comfort of their home. The platform is user-friendly and ensures data security.
                </p>
                <div className="registration-steps">
                  <div className="step-item">
                    <span className="step-number">1</span>
                    <span>Fill Application Form</span>
                  </div>
                  <div className="step-item">
                    <span className="step-number">2</span>
                    <span>Upload Documents</span>
                  </div>
                  <div className="step-item">
                    <span className="step-number">3</span>
                    <span>Complete Payment</span>
                  </div>
                </div>
                <Button 
                  label="Register Online" 
                  className="register-button"
                  icon="pi pi-user-plus"
                  style={{
                    background: '#03438F',
                    border: 'none',
                    borderRadius: '12px',
                    padding: '0.75rem 1.5rem',
                    boxShadow: '0 4px 15px rgba(3, 67, 143, 0.3)',
                    transition: 'all 0.3s ease',
                    marginTop: '1rem'
                  }}
                />
              </div>
            </Card>
          </div>

          {/* Age Criteria */}
<div className="col-12 md:col-6 mb-4">
  <Card className="admission-card h-full" style={{
    borderRadius: '20px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    border: 'none',
    overflow: 'hidden'
  }}>
    <div className="card-header-enhanced">
      <div className="flex align-items-center mb-4">
        <span className="text-3xl mr-3" style={{ color: '#F57A25' }}>👶</span>
        <h3 className="text-2xl font-bold m-0" style={{ color: '#03438F' }}>Age Criteria</h3>
      </div>
    </div>
    <div className="card-content">
      <div className="age-criteria-list">
        <div className="age-item">
          <span className="age-class">Nursery</span>
          <span className="age-range">3-4 years</span>
          <span className="age-dates">(Born 01.04.2021 - 31.03.2022)</span>
        </div>
        <div className="age-item">
          <span className="age-class">LKG</span>
          <span className="age-range">4-5 years</span>
          <span className="age-dates">(Born 01.04.2020 - 31.03.2021)</span>
        </div>
        <div className="age-item">
          <span className="age-class">UKG</span>
          <span className="age-range">5-6 years</span>
          <span className="age-dates">(Born 01.04.2019 - 31.03.2020)</span>
        </div>
        <div className="age-item">
          <span className="age-class">Class I</span>
          <span className="age-range">6-7 years</span>
          <span className="age-dates">(Born 01.04.2018 - 31.03.2019)</span>
        </div>
      </div>
      <p className="leading-relaxed mt-4" style={{ color: '#666' }}>
        As per National Education Policy (NEP) 2025-26. Age criteria ensure students are placed in the right class for 
        optimum learning, social integration, and personal growth.
      </p>
    </div>
  </Card>
</div>

          {/* Fee Structure */}
          {/* <div className="col-12 md:col-6 mb-4">
            <Card className="admission-card h-full" style={{
              borderRadius: '20px',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
              transition: 'all 0.3s ease',
              border: 'none',
              overflow: 'hidden'
            }}>
              <div className="card-header-enhanced">
                <div className="flex align-items-center mb-4">
                  <span className="text-3xl mr-3" style={{ color: '#F57A25' }}>💰</span>
                  <h3 className="text-2xl font-bold m-0" style={{ color: '#03438F' }}>Fee Structure</h3>
                </div>
              </div>
              <div className="card-content">
                <div className="fee-highlights">
                  <div className="fee-item">
                    <span className="fee-label">Annual Tuition Fee</span>
                    <span className="fee-amount">₹25,000 - ₹35,000</span>
                  </div>
                  <div className="fee-item">
                    <span className="fee-label">Transport Fee</span>
                    <span className="fee-amount">₹3,000 - ₹5,000</span>
                  </div>
                  <div className="fee-item">
                    <span className="fee-label">Development Fee</span>
                    <span className="fee-amount">₹2,000</span>
                  </div>
                </div>
                <p className="leading-relaxed mt-4" style={{ color: '#666' }}>
                  Fees are structured to provide quality education and modern facilities. 
                  Additional charges include extracurricular activities and optional programs.
                </p>
                <Button 
                  label="View Detailed Fee Structure" 
                  className="fee-button"
                  icon="pi pi-file-pdf"
                  style={{
                    background: '#F57A25',
                    border: 'none',
                    borderRadius: '12px',
                    padding: '0.75rem 1.5rem',
                    boxShadow: '0 4px 15px rgba(245, 122, 37, 0.3)',
                    transition: 'all 0.3s ease',
                    marginTop: '1rem'
                  }}
                />
              </div>
            </Card>
          </div> */}

          {/* Subject Combination */}
          {/* <div className="col-12 md:col-6 mb-4">
            <Card className="admission-card h-full" style={{
              borderRadius: '20px',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
              transition: 'all 0.3s ease',
              border: 'none',
              overflow: 'hidden'
            }}>
              <div className="card-header-enhanced">
                <div className="flex align-items-center mb-4">
                  <span className="text-3xl mr-3" style={{ color: '#F57A25' }}>📖</span>
                  <h3 className="text-2xl font-bold m-0" style={{ color: '#03438F' }}>Subject Combination</h3>
                </div>
              </div>
              <div className="card-content">
                <div className="subject-categories">
                  <div className="subject-category">
                    <h4 className="category-title" style={{ color: '#03438F' }}>Core Subjects</h4>
                    <div className="subject-tags">
                      <span className="subject-tag">Mathematics</span>
                      <span className="subject-tag">Science</span>
                      <span className="subject-tag">English</span>
                      <span className="subject-tag">Social Studies</span>
                    </div>
                  </div>
                  <div className="subject-category">
                    <h4 className="category-title" style={{ color: '#03438F' }}>Languages</h4>
                    <div className="subject-tags">
                      <span className="subject-tag">Hindi</span>
                      <span className="subject-tag">Telugu</span>
                      <span className="subject-tag">Sanskrit</span>
                    </div>
                  </div>
                </div>
                <p className="leading-relaxed mt-4" style={{ color: '#666' }}>
                  Students can choose subjects based on interest and career goals, 
                  supported by expert faculty guidance and career counseling.
                </p>
              </div>
            </Card>
          </div> */}

          {/* Board Results */}
          {/* <div className="col-12 md:col-6 mb-4">
            <Card className="admission-card h-full" style={{
              borderRadius: '20px',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
              transition: 'all 0.3s ease',
              border: 'none',
              overflow: 'hidden'
            }}>
              <div className="card-header-enhanced">
                <div className="flex align-items-center mb-4">
                  <span className="text-3xl mr-3" style={{ color: '#F57A25' }}>🏆</span>
                  <h3 className="text-2xl font-bold m-0" style={{ color: '#03438F' }}>Board Results</h3>
                </div>
              </div>
              <div className="card-content">
                <div className="results-stats">
                  <div className="result-stat">
                    <div className="stat-number">95%</div>
                    <div className="stat-label">Pass Rate</div>
                  </div>
                  <div className="result-stat">
                    <div className="stat-number">85%</div>
                    <div className="stat-label">First Division</div>
                  </div>
                  <div className="result-stat">
                    <div className="stat-number">15+</div>
                    <div className="stat-label">Years Excellence</div>
                  </div>
                </div>
                <p className="leading-relaxed mt-4" style={{ color: '#666' }}>
                  Our students consistently achieve high pass rates in CBSE board examinations, 
                  reflecting the quality of teaching and comprehensive learning support.
                </p>
              </div>
            </Card>
          </div> */}

          {/* Campus Tour Registration */}
          {/* <div className="col-12 md:col-6 mb-4">
            <Card className="admission-card h-full" style={{
              borderRadius: '20px',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
              transition: 'all 0.3s ease',
              border: 'none',
              overflow: 'hidden'
            }}>
              <div className="card-header-enhanced">
                <div className="flex align-items-center mb-4">
                  <span className="text-3xl mr-3" style={{ color: '#F57A25' }}>🏫</span>
                  <h3 className="text-2xl font-bold m-0" style={{ color: '#03438F' }}>Campus Tour</h3>
                </div>
              </div>
              <div className="card-content">
                <p className="leading-relaxed mb-4" style={{ color: '#666' }}>
                  Parents and students can register for guided campus tours to explore our 
                  facilities and interact with faculty members.
                </p>
                <div className="tour-features">
                  <div className="feature-item">
                    <span className="feature-icon">🏛️</span>
                    <span>Modern Classrooms</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-icon">🔬</span>
                    <span>Science Labs</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-icon">⚽</span>
                    <span>Sports Facilities</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-icon">📚</span>
                    <span>Library</span>
                  </div>
                </div>
                <Button 
                  label="Book Campus Tour" 
                  className="tour-button"
                  icon="pi pi-calendar-plus"
                  style={{
                    background: '#03438F',
                    border: 'none',
                    borderRadius: '12px',
                    padding: '0.75rem 1.5rem',
                    boxShadow: '0 4px 15px rgba(3, 67, 143, 0.3)',
                    transition: 'all 0.3s ease',
                    marginTop: '1rem'
                  }}
                />
              </div>
            </Card>
          </div> */}

          {/* Contact Information */}
          <div className="col-12 md:col-6 mb-4">
            <Card className="admission-card h-full" style={{
              borderRadius: '20px',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
              transition: 'all 0.3s ease',
              border: 'none',
              overflow: 'hidden'
            }}>
              <div className="card-header-enhanced">
                <div className="flex align-items-center mb-4">
                  <span className="text-3xl mr-3" style={{ color: '#F57A25' }}>📞</span>
                  <h3 className="text-2xl font-bold m-0" style={{ color: '#03438F' }}>Contact Information</h3>
                </div>
              </div>
              <div className="card-content">
                <div className="contact-details">
                  <div className="contact-item">
                    <span className="contact-icon">📱</span>
                    <div className="contact-info">
                      <h4 className="contact-label">Phone Number</h4>
                      <p className="contact-text">
1800 891 1256, 8886421212, 8886521212</p>
                    </div>
                  </div>
                  <div className="contact-item">
                    <span className="contact-icon">✉️</span>
                    <div className="contact-info">
                      <h4 className="contact-label">Email</h4>
                      <p className="contact-text">enquiry@dreamindia.com</p>
                    </div>
                  </div>
                  <div className="contact-item">
                    <span className="contact-icon">📍</span>
                    <div className="contact-info">
                      <h4 className="contact-label">Address</h4>
                      <p className="contact-text">D.No.27-13-2, Rajupeta, Tiruvuru, NTR District - 521235</p>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>

      {/* Custom CSS for enhanced styling */}
      <style jsx>{`
        .admissions-container {
          padding: 2rem;
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
          min-height: 100vh;
        }
        
        .admissions-header {
          background: white;
          border-radius: 20px;
          padding: 3rem;
          margin-bottom: 3rem;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
        }
        
        .admissions-content {
          max-width: 1200px;
          margin: 0 auto;
        }
        
        .admission-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.15) !important;
        }
        
        .card-header-enhanced {
          padding: 1.5rem 1.5rem 0 1.5rem;
        }
        
        .card-content {
          padding: 0 1.5rem 1.5rem 1.5rem;
        }
        
        .admission-benefits {
          display: flex;
          flex-wrap: wrap;
          gap: 0.75rem;
          margin-top: 1rem;
        }
        
        .benefit-item {
          display: flex;
          align-items: center;
          padding: 0.5rem 0.75rem;
          background: rgba(3, 67, 143, 0.1);
          border-radius: 20px;
          font-size: 0.875rem;
          color: #03438F;
        }
        
        .benefit-icon {
          margin-right: 0.5rem;
        }
        
        .registration-steps {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
          margin-bottom: 1rem;
        }
        
        .step-item {
          display: flex;
          align-items: center;
          padding: 0.75rem;
          background: #f8fafc;
          border-radius: 8px;
          border-left: 3px solid #03438F;
        }
        
        .step-number {
          background: #03438F;
          color: white;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.75rem;
          font-weight: bold;
          margin-right: 0.75rem;
        }
        
        .register-button:hover, .fee-button:hover, .tour-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(0,0,0,0.2) !important;
        }
        
        .age-criteria-list {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
        }
        
        .age-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.75rem;
          background: #f8fafc;
          border-radius: 8px;
          border-left: 3px solid #03438F;
        }
        
        .age-class {
          font-weight: 600;
          color: #374151;
        }
        
        .age-range {
          color: #03438F;
          font-weight: 500;
        }
        
        .fee-highlights {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
          margin-bottom: 1rem;
        }
        
        .fee-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.75rem;
          background: rgba(245, 122, 37, 0.1);
          border-radius: 8px;
        }
        
        .fee-label {
          font-weight: 500;
          color: #374151;
        }
        
        .fee-amount {
          font-weight: bold;
          color: #F57A25;
        }
        
        .subject-categories {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }
        
        .category-title {
          font-size: 1rem;
          font-weight: 600;
          margin-bottom: 0.5rem;
        }
        
        .subject-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
        }
        
        .subject-tag {
          padding: 0.25rem 0.75rem;
          background: rgba(3, 67, 143, 0.1);
          border-radius: 15px;
          font-size: 0.75rem;
          color: #03438F;
          font-weight: 500;
        }
        
        .results-stats {
          display: flex;
          gap: 1rem;
          margin-bottom: 1rem;
        }
        
        .result-stat {
          text-align: center;
          padding: 1rem;
          background: rgba(3, 67, 143, 0.1);
          border-radius: 12px;
          flex: 1;
        }
        
        .stat-number {
          font-size: 1.5rem;
          font-weight: bold;
          color: #03438F;
          margin-bottom: 0.25rem;
        }
        
        .stat-label {
          font-size: 0.75rem;
          color: #64748b;
          font-weight: 500;
        }
        
        .tour-features {
          display: flex;
          flex-wrap: wrap;
          gap: 0.75rem;
          margin-bottom: 1rem;
        }
        
        .feature-item {
          display: flex;
          align-items: center;
          padding: 0.5rem 0.75rem;
          background: rgba(3, 67, 143, 0.1);
          border-radius: 20px;
          font-size: 0.875rem;
          color: #03438F;
        }
        
        .feature-icon {
          margin-right: 0.5rem;
        }
        
        .contact-details {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }
        
        .contact-item {
          display: flex;
          align-items: center;
          padding: 1rem;
          background: #f8fafc;
          border-radius: 12px;
          border-left: 3px solid #03438F;
        }
        
        .contact-icon {
          font-size: 1.5rem;
          margin-right: 1rem;
          color: #F57A25;
        }
        
        .contact-label {
          font-weight: 600;
          color: #03438F;
          margin-bottom: 0.25rem;
          text-align: left;
        }
        
        .contact-text {
          color: #64748b;
          margin: 0;
        }
        
        @media (max-width: 768px) {
          .admissions-container {
            padding: 1rem;
          }
          
          .admissions-header {
            padding: 2rem;
          }
          
          .admission-card:hover {
            transform: none;
          }
          
          .results-stats {
            flex-direction: column;
            gap: 0.75rem;
          }
          
          .tour-features {
            flex-direction: column;
          }
          
          .admission-benefits {
            flex-direction: column;
          }
        }
      `}</style>
    </div>
  );
};

export default Admissions;